import { menusConstants } from '@constants/menus';

const initialState = {
    data: {
        menus: [],
        totalCount: 0,
        pages: 0,
    },
    loading: true,
};

export function menus(state = initialState, action) {
    switch (action.type) {
        case menusConstants.MENUS_REQUEST:
            return { ...state, loading: true };
        case menusConstants.MENUS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: {
                    menus: action.menus.items || [],
                    totalCount: action.menus.totalCount,
                    pages: action.menus.pages,
                },
            };
        case menusConstants.MENUS_ERROR:
            return { ...state, loading: false };
        default:
            return state;
    }
}
